import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

export interface ArchivoAtencion {
  id: string;
  hallazgos: string;
  archivo: {
    nombreOriginal: string;
  };
  fecha: string;
}

@Injectable({
  providedIn: 'root',
})
export class ArchivosAtencionService {
  private archivosAtencionApiUrl = `${environment.apiUrl}/archivos-atencion`;

  constructor(private http: HttpClient) {}

  // POST /archivos-atencion
  subirArchivoAtencion(
    archivo: File,
    atencionId: string,
    hallazgos: string,
  ): Observable<ArchivoAtencion> {
    const formData = new FormData();

    formData.append('file', archivo);
    formData.append('atencionId', atencionId);
    formData.append('hallazgos', hallazgos);

    return this.http.post<ArchivoAtencion>(this.archivosAtencionApiUrl, formData);
  }

  // GET /archivos-atencion/:archivoId
  obtenerArchivo(archivoId: string): Observable<Blob> {
    return this.http.get(`${this.archivosAtencionApiUrl}/${archivoId}`, {
      responseType: 'blob',
    });
  }

  // GET /archivos-atencion/all/:pacienteId
  obtenerArchivosPorPaciente(pacienteId: string): Observable<ArchivoAtencion[]> {
    return this.http.get<ArchivoAtencion[]>(`${this.archivosAtencionApiUrl}/all/${pacienteId}`);
  }

  // PATCH /archivos-atencion/:archivoId
  actualizarArchivo(
    archivoId: string,
    cambios: {
      hallazgos?: string;
      archivo?: File;
    },
  ): Observable<ArchivoAtencion> {
    const formData = new FormData();

    if (cambios.hallazgos !== undefined) {
      formData.append('hallazgos', cambios.hallazgos);
    }

    if (cambios.archivo) {
      formData.append('file', cambios.archivo);
    }

    return this.http.patch<ArchivoAtencion>(
      `${this.archivosAtencionApiUrl}/${archivoId}`,
      formData,
    );
  }

  // DELETE /archivos-atencion/:archivoId
  eliminarArchivo(archivoId: string): Observable<void> {
    return this.http.delete<void>(`${this.archivosAtencionApiUrl}/${archivoId}`);
  }
}
